import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Socket } from "socket.io-client";

import { SocketNamespace } from "@/interfaces/globals";
import { RootState } from "@/redux/store";
import { getWorkspace } from "@/utils/helpers";

export const useSocket = (
  nameSpace: SocketNamespace,
): {
  socket: Socket | null;
  isConnected: boolean;
} => {
  const token = useSelector((state: RootState) => state.user.userToken);
  const manager = useSelector((state: RootState) => state.config.manager);
  const workspace = getWorkspace();
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    const socket = manager?.socket(nameSpace, {
      ...(token
        ? {
            auth: {
              token: `Bearer ${token}`,
            },
          }
        : {}),
    });

    const onConnect = (): void => {
      setIsConnected(true);
      // toast.success("Connected to socket");
    };

    const onDisconnect = (): void => {
      setIsConnected(false);
      // toast.error("Disconnected from socket");
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    setSocket(socket);

    //  This cleanup runs before the next render
    return (): void => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, [token, manager, nameSpace, workspace]);

  return { socket, isConnected };
};
